import React from 'react';
import { DriverCellProps } from './driver-cell.types';
import useOldestEvents from '../../../../hooks/use-oldest-events';

const DriverCell = ({ row }: DriverCellProps) => {
  const { configurationCreatedEvent, vehicleConfigurationBasedOnGRVCreatedEvent, vehicleBasedOnBulkOrderCreatedEvent } =
    useOldestEvents(row?.events || []);
  const eventWithDriverName =
    configurationCreatedEvent || vehicleConfigurationBasedOnGRVCreatedEvent || vehicleBasedOnBulkOrderCreatedEvent;

  return <span>{eventWithDriverName?.uds_erstelltfurid?.name || '-'}</span>;
};

export default DriverCell;
